module.exports = __webpack_public_path__ + "img/pills-bottle.1c2749fd.svg";